module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    staticClass: "upload-video",
    attrs: {
      "drag": "",
      "action": "/wapi/base/upload",
      "file-list": _vm.fileList,
      "accept": "video/*",
      "before-upload": _vm.handleBeforeUpload,
      "on-success": _vm.handleSuccess,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "multiple": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/video_upload_icon.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('p', {
    staticClass: "bigger"
  }, [_vm._v("点击上传视频文件")]), _vm._v(" "), _c('p', {
    staticClass: "detail"
  }, [_vm._v("支持格式：.MP4 .FLV")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      }
    }
  }, [(_vm.videoUrl && _vm.videoVisible) ? _c('video', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "controls": "",
      "loop": "",
      "src": _vm.videoUrl,
      "autoplay": ""
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-deea141a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoUpload.vue
// module id = 919
// module chunks = 1